<div style="display: inline-block; width: 100%;">
    <h2 style="float: left; margin: auto 0;">Test List</h2>

    <button [routerLink]="['/reserved', 'contracts', id, 'output-list']" matTooltip="Show output list" style="float: right;  margin: auto 0;" mat-button>
        <!-- <mat-icon>list</mat-icon> -->
        Open Test Output
    </button>
</div>

<!-- <button [routerLink]="['/reserved', 'contracts', id, 'test-list']"  mat-icon-button matTooltip="Show test list">
    <mat-icon>input</mat-icon>
  </button> -->

  <mat-accordion *ngIf="!isForbidden">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon style="margin-right: 8px;">filter_list_alt</mat-icon>  Filters
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
  
      <div style="display: flex; flex-wrap: nowrap; align-items: flex-start; width: 100%;">
        <mat-form-field style="flex: 1; margin: 8px;">
          <mat-label>Keyword</mat-label>
          <input matInput placeholder="" value="" [(ngModel)]="query">
        </mat-form-field>
  
        <mat-form-field style="flex: 1; margin: 8px;">
          <mat-label>CIA</mat-label>
          <mat-select [formControl]="CIAControls" multiple>
            <mat-select-trigger>
              <mat-chip-grid>
                <mat-chip-row *ngFor="let cia of CIAControls.value"
                  [removable]="true" (removed)="removeCIAFilter(cia)" class="colored-chip">
                  {{ cia }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
              </mat-chip-grid>
            </mat-select-trigger>
            <mat-option *ngFor="let cia of CIAoptions" [value]="cia">{{ cia }}</mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field style="flex: 1; margin: 8px;">
          <mat-label>Stride</mat-label>
          <mat-select [formControl]="StrideControls" multiple>
            <mat-select-trigger>
              <mat-chip-grid>
                <mat-chip-row *ngFor="let stride of StrideControls.value"
                  [removable]="true" (removed)="removeStrideFilter(stride)" class="colored-chip">
                  {{ stride.title }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
              </mat-chip-grid>
            </mat-select-trigger>
            <mat-option *ngFor="let stride of StrideOptions" [value]="stride">{{ stride.title }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="display: flex; flex-wrap: nowrap; align-items: flex-start; width: 100%;">
        <mat-form-field style="flex: 1; margin: 8px;">
          <mat-label>Regulations</mat-label>
          <mat-select [formControl]="UneceControls" multiple>
            <mat-select-trigger>
              <mat-chip-grid>
                <mat-chip-row *ngFor="let unece of UneceControls.value"
                  [removable]="true" (removed)="removeUneceFilter(unece)"
                  [class.gb-chip]="unece?.toLowerCase().startsWith('gb')"
                  [class.unece-chip]="unece?.toLowerCase().startsWith('slt')"
                  [class.red-chip]="unece?.toLowerCase().startsWith('red')"
                  >
                  {{ unece }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
              </mat-chip-grid>
            </mat-select-trigger>
            <mat-option *ngFor="let unece of UneceOptions" [value]="extractRegulationId(unece)">{{ unece }}</mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field style="flex: 1; margin: 8px;">
          <mat-label>Interfaces</mat-label>
          <mat-select [formControl]="InterfaceControls" multiple>
            <mat-select-trigger>
              <mat-chip-grid>
                <mat-chip-row *ngFor="let iface of InterfaceControls.value"
                  [removable]="true" (removed)="removeInterfaceFilter(iface)" >
                  {{ iface.target_name }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
              </mat-chip-grid>
            </mat-select-trigger>
            <mat-option *ngFor="let iface of InterfaceOptions" [value]="iface">{{ iface.target_name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      <!-- <div style="display: flex; flex-wrap: wrap;">
        <mat-chip-grid style="flex: 1 1 100%; margin: 8px;" [(ngModel)]="searchIfaceList">
          <ng-container *ngFor="let iface of searchIfaceList">
            <mat-chip-row (removed)="removeIfaceFromSearch(iface)">
              {{ iface }}
              <button matChipRemove [attr.aria-label]="'remove ' + iface">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </ng-container>
        </mat-chip-grid>
  
        <mat-chip-grid style="flex: 1 1 100%; margin: 8px;" [(ngModel)]="searchUneceList">
          <ng-container *ngFor="let unece of searchUneceList">
            <mat-chip-row (removed)="removeUneceFromSearch(unece)" class="unece-chip">
              {{ unece }}
              <button matChipRemove [attr.aria-label]="'remove ' + unece">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </ng-container>
        </mat-chip-grid>
      </div> -->
      <button mat-raised-button color="primary" (click)="search()">Apply</button>
    </mat-expansion-panel>
  </mat-accordion>
  

  <div *ngIf="!isForbidden" style="width: 100%; height: auto; text-align: right; margin-top: 16px;">
    <button mat-button [matMenuTriggerFor]="menu">
      <mat-icon>apps</mat-icon> Status <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <div *ngFor="let b of box_status">
        <button mat-menu-item (click)="showBoxInfo(b)">
          {{b.identifier}}
          <mat-icon [ngStyle]="{'color': b.isOnline ? 'green' : 'red'}" iconPositionEnd>brightness_1</mat-icon>
        </button>
      </div>
    </mat-menu>
  </div>
  

<div class="row container-cards-basket" style = "margin-top: 10px;">
     <div [ngClass]="isForbidden ? 'col-lg-12 col-md-12 col-sm-12 col-xs-12' : 'col-lg-9 col-md-12 col-sm-12 col-xs-12'" style="overflow: auto;">
        <ng-template #loadingGeneral>
            <mat-spinner class="center"></mat-spinner>
            <p class="center">Loading...</p>
        </ng-template>
        <div *ngIf="errorMessage" class="error-message">
            {{ errorMessage }}
        </div>

        <ng-container *ngIf="!loading else loadingGeneral">
            <div class="container">
                <div class="row">
                    <div *ngFor="let test of filter" class="col-lg-4 col-sm-6 col-xs-12">
                        <aw-test-card [test]="test" (click)="openDialog(test)" />
                    </div>
                </div>
            </div>
            <ng-container [(ngModel)] = "next" *ngIf="next">
                <button mat-button style="display: block; margin: 10px auto;" (click)="loadMore()">Load More</button>
            </ng-container>
        </ng-container>
    </div>


    <mat-card *ngIf="!isForbidden" class="backet col-lg-3 col-md-12 col-sm-12 col-xs-12" style="overflow: auto;" [(ngModel)]="resume">

        <!-- <div style="display: inline-block; width: 100%;">

            <div style="float: left; margin: auto 0;">
                <div style="display: flex; align-items: center;">
                    <mat-icon aria-hidden="false" aria-label="Delete Test" fontIcon="shopping_cart"></mat-icon>
                    <h4>Basket</h4>
                </div>
            </div>

            <button mat-raised-button color="primary" (click)="lauchTests()" class="run-test-button" >Run </button>
        
        </div> -->
        <div style="display:grid; grid-template-columns: 50% 50%; align-items: center;">

            <div style="display: inline-block; width: 100%;">

                <div style="float: left; margin: auto 0;">
                    <div style="display: flex; align-items: center;">
                        <mat-icon aria-hidden="false" aria-label="Delete Test" fontIcon="shopping_cart"></mat-icon>
                        <h4>Basket</h4>
                    </div>
                </div>
    
            </div>

            <button *ngIf="resume.length > 0" mat-raised-button color="primary" (click)="lauchTests()" >Run Tests </button>
            
        
        </div>

        <div style="height: 100%; overflow: auto;">
            <ng-template *ngIf="resume.length > 0; then True else False" />
            <ng-template #True>
                <div *ngFor="let item of resume">
                    <div *ngFor="let form of item.forms" style="display: grid; grid-template-columns: 90% 10%;">
                        <div (click)="openInfoDialog(form)" style="cursor: pointer">
                             <b>{{item.title.toUpperCase()}}</b> - {{form.testname}} - iface: {{form.ifaceBox.iname}} - box: {{form.ifaceBox.box_name}}
                        </div>
                        <div style="display: flex; justify-content: center; align-items: center; cursor: pointer">
                            <mat-icon aria-hidden="false" aria-label="Delete Test" fontIcon="delete"
                                (click)="deleteTest(form)"></mat-icon>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #False>
                <p>No Test selected yet!</p>
            </ng-template>
        </div>
    </mat-card>
</div>